<div class="modal-header">
    <h3>{{titulo? titulo : 'Alerta'}}</h3>
    <button class="btn link bi bi-x-lg" aria-label="Close" (click)="confirm? aceptar(false):activeModal.dismiss()"></button>
</div>
<div class="modal-body" [innerHTML]="content"> </div>
<div class="modal-footer">
    <button *ngIf="confirm" type="button" class="btn btn-secondary" (click)="aceptar(false)">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="aceptar(true)">Aceptar</button>
</div>


